/**
 * Catálogo de rotas reais da Home do protótipo (`MENU_ITEMS` em `menu.mock.js`).
 *
 * Cruzado por CÓDIGO DE PERMISSÃO contra `src/routes/menuRoutes.jsx` — nunca
 * por texto do label, porque os labels divergem em abreviação/plural entre
 * protótipo e produção, e o agrupamento visual do protótipo não é 1:1 com o
 * agrupamento real em alguns casos (ex.: `clientes`→"Financeiro"/"Cadastros",
 * `estatisticaBorderos`→"Controle de Borderô", `borderos`→ view que pertence a
 * "Ferramentas"). Ver tabela completa de cruzamento em
 * docs/plano-navegacao-menus-prototipo.md.
 *
 * Shape por `item.id`: `string` (path direto) para itens `action` sem
 * `views`; `Record<string, string>` (label da view → path) para itens
 * `dropdown`. Item/view sem rota real mapeada simplesmente não entra aqui —
 * `manutencao` inteiro (3 das 4 views por `NO_PERMISSION_AVAILABLE`; a 4ª,
 * "Pagamento Direto", tem rota real mas duplicaria o destino já mapeado em
 * `financeiro.Pagamento Direto` — decisão do dev: mantido só em `financeiro`)
 * e todo o grupo `minhasRequisicoes` (`NO_PERMISSION_AVAILABLE`) não entram
 * aqui.
 *
 * @type {Record<string, string | Record<string, string>>}
 */
export const MENU_HOME_ROUTES = {
  consultaDinamica: '/ferramentas/consulta-dinamica',

  cadastros: {
    Parâmetros: '/parametros',
    Usuários: '/usuario',
    Filiais: '/filial',
    'Ramos de Atividade': '/ramo-atividade',
    'Fases e Pastas': '/fases',
    Requisições: '/requisicoes',
    'Texto Padrão': '/textos-padrao',
    'Títulos de Compromisso': '/titulo-de-compromisso',
  },

  financeiro: {
    'C/C de Comissionado': '/conta-corrente-comissionado',
    'C/C de Honorários': '/conta-corrente-honorario',
    'Notas Fiscais': '/notas-fiscais',
    'Notas Fiscais de Devedores': '/notas-fiscais-devedores',
    'Recebimento de Clientes': '/recebimento-clientes',
    'Recebimento de Devedores': '/recebimento-devedores',
    'Pagamento Direto': '/pagamento-direto',
  },

  analiseGerenciais: {
    'Rendimento Mensal Comercial': '/analise-gerencial/rendimento-mensal-comercial',
    'Rendimento Mensal Negociadores': '/analise-gerencial/rendimento-mensal-negociadores',
    'Clientes em Débito': '/analise-gerencial/clientes-em-debito',
    'Valores a Pagar pela ABE': '/analise-gerencial/valores-a-pagar-pela-abe',
  },

  estatisticaBorderos: {
    'Controle de Entrada': '/controle-de-bordero/controle-de-entrada',
    'Mapa de Borderôs': '/controle-de-bordero/mapa-bordero',
    'Resumo Mensal': '/controle-de-bordero/resumo-mensal',
  },

  clientes: {
    'C/C de Cliente': '/conta-corrente-cliente',
    'Dados do Cliente': '/cliente',
  },

  ferramentas: {
    'Registrar Boletos': '/ferramentas/registrar-boleto',
    'Validar Processos': '/ferramentas/validar-processo',
    'Consultar Estatísticas': '/ferramentas/estatisticas',
    'Gerar Arquivo WhatsApp': '/ferramentas/gerar-arquivo-whatsapp',
  },

  borderos: {
    Importar: '/importar-bordero',
    Incluir: '/incluir-bordero',
    Processar: '/processar-borderos',
    'Visualizar Log': '/logs-processamentos-borderos',
    'Validar Borderô': '/validar-bordero-correcao',
    'E-mail Entrada Borderô': '/ferramentas/email-entrada-bordero',
  },
};
